export default "__VITE_ASSET__58aab3c8__"